export default __webpack_public_path__ + "static/media/hbs-k-cbb-banner-3.4e6fb913.jpg";